module.exports = __webpack_public_path__ + "static/media/hi_shelf_freq.d6bed3f9.png";